"use strict";
jQuery(document).ready(function($) {
  var adpPopup = {};
  (function() {
    var $this;
    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",
      init: function(e) {
        $this = adpPopup;
        $this.popupInit(e);
        $this.events(e);
        
        window.addEventListener("resize", function() {
          $(".popup-open").each(function(_, p) {
            $this.resizePopupElements(p);
          });
        });
      },
      events: function() {
        $(document).off(".adpPopup");
        $(document).on("click.adpPopup", ".popup-close", $this.closePopup);
        $(document).on("click.adpPopup", ".popup-accept", $this.acceptPopup);
        $(document).on("click.adpPopup", ".age-verification__popup-close", $this.agePopup);
        $(document).on("click.adpPopup", ".age-verification__popup-close", $this.closePopup);
        $(document).on("click.adpPopup", ".age-verification__button-no", $this.ageDeclined);
        $(document).on("keyup.adpPopup", function(e) {
          if (e.key === "Escape") {
            $('.popup-open[data-esc-close="true"]').each(function(_, p) { $this.closePopup(p); });
          }
          if (e.key === "F4") {
            $('.popup-open[data-f4-close="true"]').each(function(_, p) { $this.closePopup(p); });
          }
        });
        $(document).on("click.adpPopup", ".popup-overlay", function() {
          $('.popup-open[data-overlay-close="true"]').each(function(_, p) { $this.closePopup(p); });
        });
      },
      resizePopupElements: function(popup) {
        var thumb = $(popup).find(".popup-thumbnail");
        if (thumb.length && ($(popup).hasClass("popup-main-image--left") || $(popup).hasClass("popup-main-image--right"))) {
          if (window.innerWidth > 749) {
            var ratio = parseFloat(thumb.data("aspect-ratio") || 1.0);
            var w = $(popup).height() * ratio;
            var maxW = $(popup).width() * 0.6;
            if (w > maxW) w = maxW;
            thumb.css("width", w + "px");
          } else {
            thumb.css("width", "100%");
          }
        }
        var bannerImg = $(popup).find(".notification-banner__image");
        if (bannerImg.length && ($(popup).hasClass("notification-banner-image--left") || $(popup).hasClass("notification-banner-image--right"))) {
          if (window.innerWidth > 749) {
            bannerImg.css("width", $(popup).height() + "px");
          } else {
            bannerImg.css("width", "100%");
          }
        }
      },
      popupInit: function() {
        $(document).off("scroll.adpPopupDirection").on("scroll.adpPopupDirection", function() {
          var scrollCurrent = window.scrollY;
          $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
          $this.sPrevious = scrollCurrent;
        });
        $(".popup").each(function(index, popup) {
          if ($(popup).data("open-trigger") === "manual") {
            var selector = $(popup).data("open-manual-selector");
            if (selector) {
              $(selector).addClass("popup-trigger");
              $(document).off("click.adpPopupManual", selector).on("click.adpPopupManual", selector, function(e) {
                e.preventDefault();
                $(popup).removeClass("popup-already-opened");
                $this.openPopup(popup);
                if (e.currentTarget.classList.contains("popup")) {
                  $this.closePopup(selector);
                }
              });
            }
          }
          if ($this.isAllowPopup(popup) || $(popup).hasClass("age-verification")) {
            $this.openTriggerPopup(popup);
          }
        });
      },
      openTriggerPopup: function(e) {
        var popup = e && e.originalEvent ? this : e;
        if ($(popup).data("has-accept") === true) {
          var id = $(popup).data("id");
          var accepted = $this.getStorage("popup-accept-" + id);
          if (accepted) return;
        }
        var trigger = $(popup).data("open-trigger");
        if (trigger === "none") {
          var ageVerification = $this.getStorage("popup-age-" + ($(popup).data("id") || 0));
          if (!ageVerification) {
            $this.openPopup(popup);
          }
        }
        if (trigger === "delay") {
          var delaySeconds = parseInt($(popup).data("open-delay-number") || 0, 10);
          setTimeout(function() {
            $this.openPopup(popup);
          }, delaySeconds * 1000);
        }
        if (trigger === "exit") {
          if ($(popup).data("exit-bound")) return;
          $(popup).data("exit-bound", true);
          var showExit = true;
          document.addEventListener("mousemove", function(ev) {
            var scroll = window.pageYOffset || document.documentElement.scrollTop;
            if (ev.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }
        if (trigger === "scroll") {
          if ($(popup).data("scroll-open-bound")) return;
          $(popup).data("scroll-open-bound", true);
          var pointScrollType = $(popup).data("open-scroll-type");
          var pointScrollPosition = parseFloat($(popup).data("open-scroll-position") || 0);
          $(document).on("scroll.adpPopupOpenScroll-" + $(popup).data("id"), function() {
            if (pointScrollType === "px" && window.scrollY >= pointScrollPosition) {
              $this.openPopup(popup);
            }
            if (pointScrollType === "%" && $this.getScrollPercent() >= pointScrollPosition) {
              $this.openPopup(popup);
            }
          });
        }
        if (trigger === "accept") {
          var accept = $this.getStorage("popup-accept-" + ($(popup).data("id") || 0));
          if (!accept) {
            $this.openPopup(popup);
          }
        }
      },
      closeTriggerPopup: function(e) {
        var popup = e && e.originalEvent ? this : e;
        var trigger = $(popup).data("close-trigger");
        if (trigger === "delay") {
          var closeDelaySeconds = parseInt($(popup).data("close-delay-number") || 0, 10);
          setTimeout(function() {
            $this.closePopup(popup);
          }, closeDelaySeconds * 1000);
        }
        if (trigger === "scroll") {
          if ($(popup).data("scroll-close-bound")) return;
          $(popup).data("scroll-close-bound", true);
          var pointScrollType = $(popup).data("close-scroll-type");
          var pointScrollPosition = parseFloat($(popup).data("close-scroll-position") || 0);
          var initScrollPx = parseFloat($(popup).data("init-scroll-px") || 0);
          var initScrollPercent = parseFloat($(popup).data("init-scroll-percent") || 0);
          $(document).on("scroll.adpPopupCloseScroll-" + $(popup).data("id"), function() {
            var p = $this.getScrollPercent();
            if (pointScrollType === "px") {
              if ($this.sDirection === "up" && window.scrollY < initScrollPx - pointScrollPosition) {
                $this.closePopup(popup);
              }
              if ($this.sDirection === "down" && window.scrollY >= initScrollPx + pointScrollPosition) {
                $this.closePopup(popup);
              }
            }
            if (pointScrollType === "%") {
              if ($this.sDirection === "up" && p < initScrollPercent - pointScrollPosition) {
                $this.closePopup(popup);
              }
              if ($this.sDirection === "down" && p >= initScrollPercent + pointScrollPosition) {
                $this.closePopup(popup);
              }
            }
          });
        }
      },
      openPopup: function(e) {
        var popup = e && e.originalEvent ? this : e;
        if ($(popup).hasClass("popup-open") || $(popup).hasClass("popup-already-opened") || !$this.isAllowPopup(popup) && !$(popup).hasClass("age-verification")) {
          return;
        }
        $("main").attr("inert", "");
        $(".shopify-section-group-footer-group").attr("inert", "");
        $(".shopify-section-group-header-group").attr("inert", "");
        $(".skip-to-content-link").attr("inert", "");

        function setupBodyScroll() {
          if ($(popup).is('[data-body-scroll-disable="true"]')) {
            if (window.innerWidth > 749) {
              $("body").addClass("popup-scroll-hidden");
            } else if ($(popup).is('[data-mobile-disable="true"]')) {
              $("body").removeClass("popup-scroll-hidden");
            }
          }
        }
        if ($(popup).is('[data-body-scroll-disable="true"]')) {
          setupBodyScroll();
          window.addEventListener("resize", function() {
            setTimeout(function() { setupBodyScroll(); }, 500);
          });
        }
        $(popup).addClass("popup-open");
        $(popup).data("init-scroll-px", window.scrollY);
        $(popup).data("init-scroll-percent", $this.getScrollPercent());
        
        setTimeout(function() {
          $this.resizePopupElements(popup);
        }, 50);

        var popupId = $(popup).data("id");
        var storageKey = "popup-" + popupId;
        var current = parseInt($this.getStorage(storageKey) || 0, 10);
        var maxLimit = parseInt($(popup).data("limit-display") || 0, 10);
        var nextValue = current + 1;
        if (maxLimit && nextValue > maxLimit) {
          nextValue = maxLimit;
        }
        $this.setStorage(storageKey, nextValue, {
          expires: $(popup).data("limit-lifetime")
        });
        var animation = $(popup).data("open-animation");
        $this.applyAnimation(popup, animation);
        $this.closeTriggerPopup(popup);
      },
      agePopup: function(e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        $this.setStorage("popup-age-" + $(popup).data("id"), 1, {
          expires: 360
        });
      },
      ageDeclined: function() {
        $(".age-verification__question").removeClass("show");
        $(".age-verification__declined").addClass("show");
      },
      acceptPopup: function(e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        $this.setStorage("popup-accept-" + $(popup).data("id"), 1, {
          expires: 360
        });
        $this.closePopup($el);
      },
      closePopup: function(e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        var animation = $(popup).data("exit-animation");
        $this.applyAnimation(popup, animation, function() {
          $(popup).addClass("popup-already-opened");
          $(popup).removeClass("popup-open");
          $("body").removeClass("popup-scroll-hidden");
        });
        $("main").removeAttr("inert", "");
        $(".shopify-section-group-footer-group").removeAttr("inert", "");
        $(".shopify-section-group-header-group").removeAttr("inert", "");
        $(".skip-to-content-link").removeAttr("inert", "");
      },
      isAllowPopup: function(popup) {
        var popupId = popup.getAttribute("data-id");
        var maxLimit = parseInt(popup.getAttribute("data-limit-display") || 0, 10);
        if (!maxLimit || window.Shopify && Shopify.designMode) return true;
        var stored = parseInt($this.getStorage("popup-" + popupId) || 0, 10);
        return stored < maxLimit;
      },
      applyAnimation: function(el, name, callback) {
        var popup = $(el).closest(".popup");
        var overlayName = typeof callback == "function" ? "popupExitFade" : "popupOpenFade";
        $(popup).next(".popup-overlay").addClass("popup-animated " + overlayName).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
          $(this).removeClass("popup-animated " + overlayName);
        });
        $(popup).find(".popup-wrap").addClass("popup-animated " + name).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
          $(this).removeClass("popup-animated " + name);
          if (typeof callback == "function") callback();
        });
      },
      getStorage: function(key) {
        var item = localStorage.getItem(key);
        if (item) {
          try {
            var parsed = JSON.parse(item);
            if (parsed.expires && Date.now() > parsed.expires) {
              localStorage.removeItem(key);
              return;
            }
            return parsed.value;
          } catch (e) {
            return;
          }
        }
      },
      setStorage: function(key, value, options) {
        options = options || {};
        var data = {
          value: value,
          expires: null
        };
        if (options.expires) {
          var expiresDate = new Date();
          expiresDate.setDate(expiresDate.getDate() + parseInt(options.expires, 10));
          data.expires = expiresDate.getTime();
        }
        localStorage.setItem(key, JSON.stringify(data));
      },
      getScrollPercent: function() {
        var h = document.documentElement;
        var b = document.body;
        var st = "scrollTop";
        var sh = "scrollHeight";
        return (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
      }
    };
  })();
  
  adpPopup.init();
  
  document.addEventListener("DOMContentLoaded", function() {
    var forms = Array.from(document.querySelectorAll("#form_contact_popup, #popup-newsletter-form"));
    forms.forEach(function(form) {
      if (form) {
        form.addEventListener("submit", function() {
          window.location.hash = "";
        });
        form.addEventListener("keydown", function(e) {
          if (e.key === "Enter") {
            const target = e.target || e.srcElement;
            if (target && target.tagName && target.tagName.toLowerCase() === "textarea") return;
            e.preventDefault();
            const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
            if (submitBtn) {
              submitBtn.click();
            } else {
              form.submit();
            }
          }
        });
      }
    });
  });
  
  document.addEventListener("shopify:section:load", function() {
    adpPopup.init();
  });
  
  document.addEventListener("shopify:section:unload", function() {
    $("body").removeClass("popup-scroll-hidden");
  });
});
